import { SVGProps, Ref, forwardRef } from 'react';

export const EmployersRatingOutlinedCircledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M17 8.05a2 2 0 1 1-4 0 2 2 0 0 1 4 0" fill="currentColor" />
            <path
                d="M13 11.8a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v5.25H7v-2a.75.75 0 0 1 .75-.75H10v-.875a.75.75 0 0 1 .75-.75H13z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12m1.8 0c0-2.483.624-4.772 1.989-6.41C6.106 4.01 8.308 2.8 12 2.8s5.894 1.21 7.211 2.79C20.576 7.228 21.2 9.517 21.2 12s-.624 4.772-1.989 6.41C17.894 19.99 15.692 21.2 12 21.2s-5.894-1.21-7.211-2.79C3.424 16.772 2.8 14.483 2.8 12"
                fill="currentColor"
            />
        </svg>
    )
);
EmployersRatingOutlinedCircledSize24Glyph.displayName = 'EmployersRatingOutlinedCircledSize24Glyph';
